/**
 * @tabler/icons-react v2.44.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconStairs = createReactComponent("stairs", "IconStairs", [
  ["path", { d: "M22 5h-5v5h-5v5h-5v5h-5", key: "svg-0" }]
]);

export { IconStairs as default };
//# sourceMappingURL=IconStairs.js.map
